import React from 'react';

import './textArea.scss';

function TextArea(props) {
  return <textarea className="ui-textArea" rows={3} {...props} />;
}

export default TextArea;
